import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteLogo } from '../components/SiteLogo';
import { LandingHero } from '../components/landing/LandingHero';
import { FormEmbed } from '../components/landing/FormEmbed';
import { PackageHighlights } from '../components/landing/PackageHighlights';
import { BravoFeature } from '../components/landing/BravoFeature';
import { PressLogos } from '../components/landing/PressLogos';
import { RealWeddings } from '../components/landing/RealWeddings';
import { TestimonialBand } from '../components/landing/TestimonialBand';
import { SiteFooter } from '../components/landing/SiteFooter';
import type { LandingVariant } from '../types/landing';
type LandingPageProps = {
  variant: LandingVariant;
};
export function LandingPage({
  variant
}: LandingPageProps) {
  useEffect(() => {
    document.title = variant.pageTitle;
    window.scrollTo(0, 0);
  }, [variant]);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-108" data-mp="lmnz55sb5264">
      <header className="px-6 pt-6 md:px-10" data-id="element-109" data-mp="2zj6zd6jhbr69">
        <Link to={`/${variant.slug}`} aria-label="Twenty Mile House home" className="inline-block" data-id="element-110" data-mp="2zk8ebm3m8xt9">
          <SiteLogo data-id="element-111" data-mp="33l1z46lrhwhx" />
        </Link>
      </header>
      <main data-id="element-112" data-mp="38jvds2csbtjo">
        <LandingHero eyebrow={variant.eyebrow} headline={variant.headline} intro={variant.intro} data-id="element-113" data-mp="38j3gmn3jhnra" />
        <FormEmbed lead={variant.formLead} data-id="element-114" data-mp="3davcnd5gslot" />
        <PackageHighlights stats={variant.stats} data-id="element-115" data-mp="3dbmttiybegvk" />
        <BravoFeature data-id="element-116" data-mp="3i9y600c313gy" />
        <PressLogos data-id="element-117" data-mp="3i8dd0f5f1sl7" />
        <RealWeddings data-id="element-118" data-mp="3i9571ljd7i9d" />
        <TestimonialBand data-id="element-119" data-mp="3ibrab8z83bls" />
      </main>
      <SiteFooter data-id="element-120" data-mp="3n7q79kyma1xt" />
    </div>;
}